/**
 * Widget Actions Rapides Locataire
 * Simple et élégant
 */

import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar
} from '@mui/material';
import {
  Search as SearchIcon,
  Event as EventIcon,
  Favorite as FavoriteIcon,
  Person as PersonIcon,
  History as HistoryIcon,
  Help as HelpIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { DashboardWidget } from '../DashboardBase';
import { QUICK_ACTIONS, DASHBOARD_TYPES } from '../../../constants/dashboardConstants';

const ICON_COMPONENTS = {
  Search: SearchIcon,
  Event: EventIcon,
  Favorite: FavoriteIcon,
  Person: PersonIcon,
  History: HistoryIcon,
  Help: HelpIcon
};

const RenterQuickActionsWidget = ({ actions, loading }) => {
  const navigate = useNavigate();

  // Actions par défaut + actions contextuelles
  const defaultActions = QUICK_ACTIONS[DASHBOARD_TYPES.RENTER];
  const contextualActions = [
    {
      action: 'view_history',
      label: 'Historique des voyages',
      icon: 'History',
      color: 'secondary',
      route: '/renter/history'
    },
    {
      action: 'get_help',
      label: 'Centre d\'aide',
      icon: 'Help',
      color: 'info',
      route: '/help'
    }
  ];

  const allActions = [...(actions || defaultActions), ...contextualActions];

  const handleActionClick = (action) => {
    if (action.route) {
      navigate(action.route);
    } else {
      switch (action.action) {
        case 'search_listings':
          navigate('/search');
          break;
        case 'view_reservations':
          navigate('/renter/reservations');
          break;
        case 'view_favorites':
          navigate('/renter/favorites');
          break;
        case 'manage_profile':
          navigate('/profile');
          break;
        case 'view_history':
          navigate('/renter/history');
          break;
        case 'get_help':
          navigate('/help');
          break;
        default:
          console.log('Action non gérée:', action.action);
      }
    }
  };

  
};

export default RenterQuickActionsWidget;
